export default "__VITE_ASSET__BiLKrbxP__"